/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Assignment Date Field
 *
 * @file AssignmentDateField.jsx
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import DateTextField from '../common/DateTextField';
import Icon from '../icons/Icon';

const AssignmentDateField = ({
  name,
  control,
  label,
  rules,
  filterDate,
  dateFormat,
  placeholderText
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field, fieldState }) => (
      <DateTextField
        className="assignment-form-date-field"
        label={label}
        value={field.value}
        onChange={(event) => field.onChange(event.target.value)}
        parentApp="aet"
        icons={{ calendar: <Icon name="CalendarIcon" /> }}
        hasError={Boolean(fieldState.error)}
        // Host can pass locale numeric format; keep US defaults when omitted.
        placeholderText={placeholderText || 'mm/dd/yyyy'}
        dateFormat={dateFormat || 'MM/dd/yyyy'}
        filterDate={filterDate}
      />
    )}
  />
);

AssignmentDateField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  rules: PropTypes.object,
  filterDate: PropTypes.func,
  dateFormat: PropTypes.string,
  placeholderText: PropTypes.string
};

AssignmentDateField.defaultProps = {
  rules: undefined,
  filterDate: null,
  dateFormat: '',
  placeholderText: ''
};

export default AssignmentDateField;
